import AdditionalCostDetail from './AdditionalCostDetail.vue';

export default AdditionalCostDetail;
